module.exports = __webpack_public_path__ + "3891fca8fe0dd00e4425863a37ded7ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Half Moon@2x.png
// module id = 322
// module chunks = 0